import { HttpTypes } from '@/types';
import { ICategory } from '@/types/category';
import { AxiosInstance } from 'axios';

class Categories {
  private readonly client: AxiosInstance;
  private readonly routePath = '/product/category';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async listAll(params?: HttpTypes.FindParams): Promise<HttpTypes.IResponse<ICategory[]>> {
    const result = await this.client.get(`${this.routePath}`, { params });
    return result.data;
  }

  async listAllParent(params?: HttpTypes.FindParams): Promise<HttpTypes.IResponse<ICategory[]>> {
    const result = await this.client.get(`${this.routePath}/parent`, { params });
    return result.data;
  }

  async sync(): Promise<HttpTypes.IResponse<null>> {
    const result = await this.client.get(`${this.routePath}/sync`);
    return result.data;
  }
}

export default Categories;
